import * as RadixScrollArea from '@radix-ui/react-scroll-area';
import { type ComponentProps, type ForwardedRef, forwardRef } from 'react';
import styles from './ScrollArea.module.scss';
type Props = {
  className?: string;
  dir?: 'ltr' | 'rtl';
  onScroll?: (event: React.UIEvent<HTMLDivElement, UIEvent>) => void;
  orientation?: 'horizontal' | 'vertical';
  scrollHideDelay?: number;
  type?: 'always' | 'auto' | 'hover' | 'scroll';
  viewPortClassName?: string;
} & ComponentProps<'div'>;
const ScrollAreaWithoutRef = ({
  children,
  className,
  dir,
  onScroll,
  orientation = 'vertical',
  scrollHideDelay = 600,
  type = 'always',
  viewPortClassName,
  ...divProps
}: Props, ref: ForwardedRef<HTMLDivElement>) => {
  const handleScroll = (event: React.UIEvent<HTMLDivElement, UIEvent>) => {
    if (onScroll) {
      onScroll(event);
    }
  };
  return <RadixScrollArea.Root className={className} {...divProps as Record<string, unknown>} dir={dir} ref={ref} scrollHideDelay={scrollHideDelay} type={type} data-sentry-element="unknown" data-sentry-component="ScrollAreaWithoutRef" data-sentry-source-file="ScrollArea.tsx">
      <RadixScrollArea.Viewport className={viewPortClassName} onScroll={handleScroll} data-sentry-element="unknown" data-sentry-source-file="ScrollArea.tsx">
        {children}
      </RadixScrollArea.Viewport>
      <RadixScrollArea.Scrollbar className={styles.scrollbar} orientation={orientation} data-sentry-element="unknown" data-sentry-source-file="ScrollArea.tsx">
        <RadixScrollArea.Thumb className={styles.thumb} data-sentry-element="unknown" data-sentry-source-file="ScrollArea.tsx" />
      </RadixScrollArea.Scrollbar>
      <RadixScrollArea.Corner className={styles.corner} data-sentry-element="unknown" data-sentry-source-file="ScrollArea.tsx" />
    </RadixScrollArea.Root>;
};

/** https://www.radix-ui.com/primitives/docs/components/scroll-area */
export const ScrollArea = forwardRef(ScrollAreaWithoutRef);